<template>
    <div class="nav-sidebar-lotto__filter">
        <CustomCheckbox
            v-for="type in systemSelectors"
            :key="type.name"
            :value="type.selected"
            :name="type.name"
            :label="type.name"
            :translateLabel="false"
            @valueChanged="onValueChanged"
            class="nav-sidebar-lotto__filter-option"
        />
    </div>
</template>

<script>
    import StoreUtil from '@app/store/StoreUtil';
    import CustomCheckbox from '@src/terminal/app/modules/lotto/shared/components/forms/CustomCheckbox';

    export default {
        name: 'SystemFilterContainer',
        props: {
            lottoNamespace: {
                type: String,
                required: true,
            },
        },
        computed: {
            ...StoreUtil.mapGettersDynamic('lottoNamespace', [
                'systemSelectors',
                'allSystemsSelected',
            ]),
        },
        methods: {
            ...StoreUtil.mapActionsDynamic('lottoNamespace', [
                'toggleSystem',
                'toggleAllSystem',
            ]),
            onValueChanged(value, name) {
                if (name === this.$t('all')) {
                    this.toggleAllSystem();
                } else {
                    if (this.allSystemsSelected) {
                        this.toggleAllSystem();
                    }
                    this.toggleSystem(name);
                }
            }
        },
        components: {
            CustomCheckbox
        }
    };
</script>



// WEBPACK FOOTER //
// src/terminal/app/modules/shared/lotto/SystemFilterContainer.vue